import React, { useState } from "react";
import SelectStyled from "../Select";
import useApi from "../../api";
import { toast } from "react-toastify";

interface TransferReservationActionProps {
  options: any[];
  reservation: any;
  onUpdate: () => void;
}

const TransferReservationAction: React.FC<TransferReservationActionProps> = ({
    options,
    reservation,
    onUpdate,
    }) => {
    const [formData, setFormData] = useState<any>([]);
    const [errorData, setErrorData] = useState<any>(null);
    const api = useApi();

  const handleTransfer = (e: React.FormEvent) => {
    e.preventDefault();
    api.transferStockReservation(reservation, formData).then((response: any) => {
        onUpdate();
        toast.success("Stock updated successfully!");
      }, (error) => {
        toast.error("Failed to update stock!");
        setErrorData(error.response.data);
      }
    );
  };

  const onSelectChange = (value: any) => {
    setFormData({'destination': value});
  };

  return (
    <td className="px-8 py-4 whitespace-nowrap min-w-[200px]">
        <div className="flex items-center space-x-4">
            <SelectStyled
              options={options}
              name="destination"
              onChange={(e: any) => onSelectChange(e.value)}
              menuPortalTarget={document.body}
              customStyles={{
              menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
          }}
            />
            <a
            onClick={handleTransfer}
            className="cursor-pointer inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-gray-600 text-base font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:text-sm"
            >
            Merge 
            </a>
        </div>
    </td>

  );
};

export default TransferReservationAction;
